var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("DeleteDialog", {
        attrs: {
          title: "Löschen",
          text: "Einheit wirklich löschen?",
          deleteMode: _vm.deleteMode,
          confirmCallback: _vm.deleteOrderPanel
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-bottom": "30px" } },
        [
          _vm.orders != null
            ? _c("el-pagination", {
                attrs: {
                  "hide-on-single-page": true,
                  layout: "total, prev, pager, next, jumper",
                  "page-size": _vm.orders.per_page,
                  "current-page": _vm.currentPage,
                  total: _vm.orders.total
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.currentPage = $event
                  },
                  "current-change": _vm.handlePaginationChange
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("Bestellungen")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { padding: "3px 10px", "margin-left": "20px" },
                  attrs: { type: "success", plain: "" },
                  on: { click: _vm.handleExportOrdersClick }
                },
                [_vm._v("Exportieren\n            ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.handleRefreshClick }
                },
                [_vm._v("Aktualisieren")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("el-input", {
                staticStyle: { width: "auto" },
                attrs: { placeholder: "Benutzer" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearchOrderByName.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.searchByName,
                  callback: function($$v) {
                    _vm.searchByName = $$v
                  },
                  expression: "searchByName"
                }
              }),
              _vm._v(" "),
              _c("el-button", {
                attrs: {
                  slot: "append",
                  icon: "el-icon-search",
                  loading: _vm.loading
                },
                on: { click: _vm.handleSearchOrderByName },
                slot: "append"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.orders != null
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.orders.data }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand", align: "left", width: "30" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-row",
                                {
                                  staticClass: "RowTemplate",
                                  attrs: { gutter: 20 }
                                },
                                [
                                  _c("RowTemplate", {
                                    attrs: { row: scope.row },
                                    on: {
                                      emitComment: _vm.updateComment,
                                      emitDeletePanel: function($event) {
                                        return _vm.deletePanelClickHandler(
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1061598070
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      align: "center",
                      width: "60"
                    }
                  }),
                  _vm._v(" "),
                  _vm.user_is_admin
                    ? _c("el-table-column", {
                        attrs: {
                          label: "Supplier",
                          prop: "supplier.supplier_name",
                          align: "center",
                          width: "150"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Benutzer", align: "center", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "hover",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("strong", [_vm._v("Adresse")]),
                                  _vm._v(
                                    ": " +
                                      _vm._s(scope.row.customer_street) +
                                      " " +
                                      _vm._s(scope.row.customer_house_nr) +
                                      ", " +
                                      _vm._s(scope.row.customer_zip) +
                                      " " +
                                      _vm._s(scope.row.customer_city) +
                                      "\n                        "
                                  ),
                                  _c("p", [
                                    _c("strong", [_vm._v("Telefonnummer")]),
                                    _vm._v(
                                      ": " + _vm._s(scope.row.customer_phone)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [_vm._v("E-mail")]),
                                    _vm._v(
                                      ": " + _vm._s(scope.row.customer_email)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  scope.row.customer_order_additional_info
                                    ? _c("div", [
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row
                                                .customer_order_additional_info
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "name-wrapper",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        { attrs: { size: "medium" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.customer_firstname
                                            ) +
                                              " " +
                                              _vm._s(
                                                scope.row.customer_lastname
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1454778639
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "total_amount",
                      align: "center",
                      label: "Total"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "name-wrapper" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_wording(
                                        "currency",
                                        scope.row.supplier_id
                                      )
                                    ) +
                                      " " +
                                      _vm._s(scope.row.total_amount)
                                  )
                                ])
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1946110974
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "panels",
                      align: "center",
                      width: "80",
                      label: "Anzahl"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "name-wrapper" }, [
                                _c("p", [
                                  _vm._v(_vm._s(scope.row.panels.length))
                                ])
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4241941918
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "created_at",
                      label: "Datum"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "120", label: "Status" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.status === "active"
                                        ? "success"
                                        : scope.row.status === "inactive"
                                        ? "danger"
                                        : "warning"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(scope.row.status) +
                                      " "
                                  ),
                                  scope.row.comment
                                    ? _c("i", {
                                        staticClass: "el-icon-s-comment"
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3931442086
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "150", label: "Aktionen" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-dropdown",
                                { attrs: { trigger: "click" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v(
                                        "\n                            Status bearbeiten"
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.status === "active"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.handleStatusAction(
                                                scope.$index,
                                                scope.row.id,
                                                "active"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Aktivieren\n                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.status === "in_progress"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.handleStatusAction(
                                                scope.$index,
                                                scope.row.id,
                                                "in_progress"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                In Bearbeitung setzen"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.status === "inactive"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.handleStatusAction(
                                                scope.$index,
                                                scope.row.id,
                                                "inactive"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Deaktivieren\n                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.status !== "inactive"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.deleteOrder(
                                                scope.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Löschen\n                            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      79643349
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-top": "30px" } },
        [
          _vm.orders != null
            ? _c("el-pagination", {
                attrs: {
                  "hide-on-single-page": true,
                  layout: "total, prev, pager, next, jumper",
                  "page-size": _vm.orders.per_page,
                  "current-page": _vm.currentPage,
                  total: _vm.orders.total
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.currentPage = $event
                  },
                  "current-change": _vm.handlePaginationChange
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebc892fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc892fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/pages/order/template.html
// module id = null
// module chunks = 